import { useState } from "react";
import { AssistantChat } from "../components/Assistant/AssistantChat";
import HistoryDrawer from "../components/Assistant/HistoryDrawer";

export default function AssistantDashboard() {

    const [sessionId, setSessionId] = useState<number>(-1);
    const [isOpen, setIsOpen] = useState(true);

    const setSessionState = (sessionId: number) => {
        setSessionId(sessionId);
    }

    return (
        <div>
            <div
                className="fixed inset-0 bg-cover bg-center bg-light dark:bg-dark -z-10"
            />
            <div className="inset-0 flex items-center justify-center absolute">
                {sessionId !== -1 &&
                    <AssistantChat sessionId={sessionId} />
                }
            </div>
            <HistoryDrawer startOpen={isOpen} setSessionState={setSessionState} />
        </div>
    );
}